module.exports = __webpack_public_path__ + "img/diverror.17c4a567.svg";